<template>
  <div class="ts-space-y-2">
    <div class="row" v-if="!isUpdate">
      <div class="col-md-12">
        <label class="required ts-text-xs">{{
          $t('allowanceCondition.pgLevel')
        }}</label>
        <input
          v-model.number="model.pg_level"
          type="number"
          class="form-control"
          :class="{ 'is-invalid': errors.has('pg_level') }"
        />
        <div class="invalid-feedback ts-text-xs" v-if="errors.has('pg_level')">
          {{ errors.first('pg_level') }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <label class="ts-text-xs">{{
          $t('allowanceCondition.mealAllowance')
        }}</label>
        <input
          v-model.number="model.meal_allowance"
          class="form-control"
          :class="{ 'is-invalid': errors.has('meal_allowance') }"
        />
        <div
          class="invalid-feedback ts-text-xs"
          v-if="errors.has('meal_allowance')"
        >
          {{ errors.first('meal_allowance') }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <label class="required ts-text-xs">{{
          $t('allowanceCondition.accommodationAllowance')
        }}</label>
        <input
          v-model.number="model.accommodation_allowance"
          class="form-control"
          :class="{ 'is-invalid': errors.has('accommodation_allowance') }"
        />
        <div
          class="invalid-feedback ts-text-xs"
          v-if="errors.has('accommodation_allowance')"
        >
          {{ errors.first('accommodation_allowance') }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <label class="required ts-text-xs">{{
          $t('allowanceCondition.dayReturnAllowance')
        }}</label>
        <input
          v-model.number="model.day_return_allowance"
          class="form-control"
          :class="{ 'is-invalid': errors.has('day_return_allowance') }"
        />
        <div
          class="invalid-feedback ts-text-xs"
          v-if="errors.has('day_return_allowance')"
        >
          {{ errors.first('day_return_allowance') }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 ts-mt-3 text-right">
        <ts-button class="mr-2" @click.prevent="() => $emit('cancel')">
          {{ $t('cancel') }}
        </ts-button>
        <ts-button
          v-if="!isUpdate"
          color="primary"
          @click.prevent="onSave"
          :waiting="waiting"
          >{{ $t('save') }}</ts-button
        >
        <ts-button
          v-if="isUpdate"
          color="primary"
          @click.prevent="onUpdate"
          :waiting="waiting"
          >{{ $t('update') }}</ts-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'

export default {
  name: 'AllowanceConditionForm',
  data() {
    return {
      errors: new Errors(),
      waiting: false,
      waiting_new: false,
      model: {
        id: null,
        pg_level: null,
        meal_allowance: null,
        accommodation_allowance: null,
        day_return_allowance: null
      }
    }
  },
  created() {
    this.setEditData()
  },
  computed: {
    ...mapState('mission/allowanceCondition', ['edit_data']),
    isUpdate() {
      return !_.isEmpty(this.edit_data)
    }
  },
  methods: {
    onSave() {
      this.waiting = true
      this.$store
        .dispatch('mission/allowanceCondition/store', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('fetchData')
          this.$emit('cancel')
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    onUpdate() {
      this.waiting = true
      this.$store
        .dispatch('mission/allowanceCondition/update', {
          id: this.model.id,
          data: this.model
        })
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('fetchData')
          this.$emit('cancel')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    setEditData() {
      if (!_.isEmpty(this.edit_data)) {
        this.model.id = this.edit_data.id
        this.model.meal_allowance = this.edit_data.meal_allowance
        this.model.accommodation_allowance = this.edit_data.accommodation_allowance
        this.model.day_return_allowance = this.edit_data.day_return_allowance
      }
    }
  }
}
</script>
